
import React from "react";
import { css } from "aphrodite";
import { inject } from "mobx-react";
import { appStore } from "src/mobx/AppStore";
import { Application } from "src/core/application";
import {styles} from "./TableauCostSharePageStyle";
import {dashboard_base} from "./Setting";

interface IPageProps {
    history: any
}




export class TableauCostSharePage extends React.Component<IPageProps> {
   private ref: any;

  constructor (props: IPageProps) {
	super(props);
    this.ref =React.createRef();
	}

  public componentDidMount() {
      this.initViz();
      }
      public initViz() {
      const host_url =dashboard_base + "Cost_share_dash";
      const options ={
                       hideToolbar: true,
                       device: "desktop",
                       hideTabs: true,
                       embed: "yes",
                       onFirstInteractive: () => {console.log("Run this code when the viz has finished loading.")
                       const workbook = Viz.getWorkbook();
                       const activeSheet = workbook.getActiveSheet();
                       window.workbook =workbook;
                       window.activeSheet =activeSheet;
                       }
                  }
      const Viz =new window.tableau.Viz(this.ref.current, host_url, options)
      }


    public render() {
    console.log('render')
        return (
                <div className={css(styles.dashContainer)}>
                <div className ="tableauPlaceholder "ref={this.ref}> </div>
                     	   </div>



         );
    }
    }

export default TableauCostSharePage;



// WEBPACK FOOTER //
// ./src/pages/TableauCostSharePage.tsx